import React from 'react';
import { Link } from 'react-router-dom';

const Links = ({linkProp}) => {
  
  return (
    <>
    {linkProp.type === "D" &&
    <li className="list-none animate-slow-down">
      <Link to={linkProp.pag} className="font-special block py-2 px-3 rounded md:border-0 md:p-0 text-white text-center">
        {linkProp.dsLink}
      </Link>
    </li>
    }
    {linkProp.type === "W" &&
      <Link to={linkProp.pag} className="font-special block py-2 px-3 rounded md:border-0 md:p-0 text-verm-profundo text-center">
        {linkProp.dsLink}
      </Link>
    }
    </>
  )
}

export default Links